import { Link } from 'react-router-dom';
import { LEGAL_LANGS, legalPath, type LegalDocKey } from '../legalDocs';

const LABEL: Record<string, string> = {
  en: 'EN',
  es: 'ES',
  pt: 'PT',
  fr: 'FR',
  de: 'DE',
  it: 'IT',
};

interface Props {
  doc: LegalDocKey;
  activeLang: string;
}

/** Language switcher — navigates to the canonical /{doc}/{lang} URL so each
 * language is shareable and SEO-addressable. */
export const LegalLanguageSelector = ({ doc, activeLang }: Props) => (
  <nav aria-label="Language" className="flex items-center gap-1 text-xs">
    {LEGAL_LANGS.map((lng, i) => (
      <span key={lng} className="flex items-center gap-1">
        {i > 0 && <span aria-hidden="true" className="text-border">·</span>}
        <Link
          to={legalPath(doc, lng)}
          aria-current={activeLang === lng ? 'page' : undefined}
          className={
            activeLang === lng
              ? 'text-brand font-medium'
              : 'text-muted-foreground hover:text-foreground transition-colors'
          }
        >
          {LABEL[lng]}
        </Link>
      </span>
    ))}
  </nav>
);

export default LegalLanguageSelector;
